import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import MuiExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiList from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import MuiListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import pxToRem from "libs/pxToRem";
import { IListItem } from "api/types/originacion/commonTypes";
import ClickAwayListener from "@mui/material/ClickAwayListener";

interface IFilterSelector {
  value: string;
  onChange(newValue: string): void;
  items: IListItem[];
  emptyListText?: string;
}

const FilterSelector = ({
  value,
  onChange,
  items = [],
  emptyListText,
}: IFilterSelector) => {
  const [optionsExpanded, setOptionsExpanded] = useState(false);
  const onItemClick = (item: IListItem) => {
    setOptionsExpanded(false);
    if (onChange) onChange(item.value as string);
  };
  const handleClickAway = () => {
    setOptionsExpanded(false);
  };
  const toggleOptionsExpanded = () => {
    setOptionsExpanded(!optionsExpanded);
  };
  const classes = useStyles();
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <SelectorRoot>
        <IconButton
          onClick={toggleOptionsExpanded}
          style={{ height: pxToRem(30) }}
          className={
            optionsExpanded
              ? classes.selectorExpanded
              : classes.selectorNotExpanded
          }
          size="large">
          <InputBox>{items.find((x) => x.value === value)?.label}</InputBox>
          <IconExpand>
            <ExpandMoreIcon />
          </IconExpand>
        </IconButton>
        {optionsExpanded && (
          <ListPaper>
            <List>
              {items.map((item, idx) => (
                <ListItem
                  button
                  divider={idx !== items.length - 1}
                  onClick={() => {
                    onItemClick(item);
                  }}
                  key={idx}
                >
                  <ListItemText primary={item.label} disableTypography />
                </ListItem>
              ))}
              {items.length === 0 && (
                <ListItem>
                  <ListItemText primary={emptyListText} disableTypography />
                </ListItem>
              )}
            </List>
          </ListPaper>
        )}
      </SelectorRoot>
    </ClickAwayListener>
  );
};

export default FilterSelector;

const SelectorRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  background: "white",
  position: "relative",
});
const InputBox = styled("div")({
  display: "flex",
  padding: "0px 20px 0px 0px",
  flex: 1,
  fontSize: 12,
  fontWeight: "bold",
  lineHeight: "1.25",
  textAlign: "left",
  color: "grey",
});
const IconExpand = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderLeft: "solid 1px #e4e4e6",
  borderRadius: "0px 5px 5px 0px",
  padding: "0px 10px 0px 10px",
  color: "grey",
  height: "100%",
});
const ListPaper = styled("div")({
  border: "solid 1px #e4e4e6",
  borderRadius: "0 0 5px 5px",
  display: "block",
  position: "absolute",
  zIndex: 1,
  width: "100%",
  background: "white",
  top: pxToRem(29),
});
const List = styled(MuiList)({
  padding: 0,
});
const ListItemText = styled(MuiListItemText)({
  display: "flex",
  flex: 1,
  fontSize: 12,
  lineHeight: "1.25",
  textAlign: "left",
  color: "grey",
  paddingLeft: 0,
  margin: 0,
});

const ExpandMoreIcon = styled(MuiExpandMoreIcon)({
  width: "1.8rem",
  height: "100%",
});
const useStyles = makeStyles({
  selectorExpanded: {
    display: "flex",
    padding: "0px 0px 0px 10px",
    borderRadius: "5px 5px 0px 0px",
    borderLeft: "solid 1px #e4e4e6",
    borderRight: "solid 1px #e4e4e6",
    borderTop: "solid 1px #e4e4e6",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  selectorNotExpanded: {
    display: "flex",
    padding: "0px 0px 0px 10px",
    borderRadius: "5px",
    border: "solid 1px #e4e4e6",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
});
